
import { Component } from '@angular/core';
import { NotificationService } from "../../services/notification.service";
import {ForgeRockUriManagementService} from "./forgerock-uri-management-service";
import {Utils} from "../../utils/utils";

@Component({
    selector: "mainsystemdetails",
    template: require("./forgerock-uri-management.component.html")
})
export class ForgerockUriManagementComponent {
    applicationId: string;
    uriString : string;
    uris: Array<string>;
    currentUrlToInput: string;
    validationErrorMessage: string;
    currentTab = "redirectUri";

    constructor(private service: ForgeRockUriManagementService, private notifier: NotificationService) {
        this.notifier.clear();
    }

    initializeTab(tabName: string) {
        this.uriString = "";
        this.applicationId = "";
        this.currentTab = tabName;
        this.notifier.clear();
    }

    updateUris() {
        this.populateUriArray();
        if (Utils.isGuidValid(this.applicationId) === false) {
            this.notifier.displayError("Please enter a valid application Guid");
            return;
        }
        if (this.areUrisValid() === false) {
            this.notifier.displayError(`Input validation failed ${this.validationErrorMessage}`);
            return;
        }
        if (this.currentTab === "redirectUri") {
            this.updateRedirectUris();
        } else {
            this.updateLogoutUris();
        }
    }

    updateRedirectUris() {
        this.notifier.displayInfo("Updating Uri(s)");
            this.service.updateRedirectUris(this.applicationId, this.uris)
                .subscribe(
                response => {
                        this.notifier.displaySuccess(`Successfully updated the Uris. Status:${response.reasonPhrase}. Request Id:${response.data}`);
                    },
                    error => {
                        this.notifier.displayError(`Failed to update Uris. Status:${error.reasonPhrase}. Request Id:${error.data}`);
                    }
                );
    }

    updateLogoutUris() {
        this.service.updateLogoutUri(this.applicationId, this.uris)
            .subscribe(
            response => {
                    this.notifier.displaySuccess(`Successfully updated the Uris. Status:${response.reasonPhrase}. Request Id:${response.data}`);
                },
                error => {
                    this.notifier.displayError(`Failed to update Uris. Status:${error.reasonPhrase}. Request Id:${error.data}`);
                }
            );
    }

    areUrisValid(): boolean {
        for (var uri of this.uris) {
            if (Utils.isUriValid(uri) === false) {
                this.validationErrorMessage = `Uri ${uri} is invalid`;
                return false;
            }    
        }
        return true;
    }

    populateUriArray() {
        if (Utils.isNullOrEmpty(this.uriString)) {
            this.notifier.displayError(`Please enter one or more valid Urls`);
            return;
        } else {
            this.uris = this.uriString.split("\n");
        }
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/forgerockUriManagement/forgerock-uri-management.component.ts
 **/